module.exports = __webpack_public_path__ + "static/media/denmark-flag.61986758.png";